module.exports = __webpack_public_path__ + "img/lupa-icon.bde64b3.svg";